import PropTypes from 'prop-types';
import { Button, Inline } from '@etg/wings';
import { LoadingDots } from '@eti/components';
import { css } from '@eti/styles';

const customStyles = css`
  min-width: 135px;
`;

const LoadMoreButton = ({ buttonText, isSearchLoading, setFetchMoreResults }) => {
  return (
    <Inline align="center">
      <Button
        className={customStyles}
        data-testid="loadmore-button"
        onClick={() => setFetchMoreResults(true)}
        variant="secondary"
      >
        {isSearchLoading ? <LoadingDots dataTestId="loading-dots" /> : buttonText}
      </Button>
    </Inline>
  );
};

LoadMoreButton.propTypes = {
  buttonText: PropTypes.string,
  isSearchLoading: PropTypes.bool,
  setFetchMoreResults: PropTypes.func,
};

export default LoadMoreButton;
